import { render, staticRenderFns } from "./FormRegional.vue?vue&type=template&id=6c70c6c2"
import script from "./FormRegional.vue?vue&type=script&lang=js"
export * from "./FormRegional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports